import { ApplicationSession } from '@ai-doc-automation/ui';
import { httpClient } from '@/services/api-client';

export const applicationSession = new ApplicationSession(httpClient, 'client-web');
